function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";

/*
 *  Header Navigation
 *    Scripts for the header navigation
 *
 *  Version:
 *    1.0.0 - 2020/10/19
 */
import { initCarousel } from '../../objects/carousel';
import { responsiveMediaBelow, responsiveQuery } from './../../settings/responsive';
import { CLASS_MENU_OPEN, CLASS_PROMOBAR, CLASS_IS_SUBMENUING, CLASS_IS_SUBSUBMENUING, CLASS_MEGANAV_OPEN } from '../../tools/constants/classes'; // Selectors

var SELECTOR_HEADER = '[data-header]';
var SELECTOR_SUBMENU_CONTAINER = '[data-submenu-container]';
var SELECTOR_SUBMENU_TRIGGER = '[data-mobile-submenu-trigger]';
var SELECTOR_SUBSUBMENU_TRIGGER = '[data-mobile-subsubmenu-trigger]';
var SELECTOR_SUBMENU_CLOSE = '[data-mobile-submenu-close]';
var SELECTOR_SUBSUBMENU_CLOSE = '[data-mobile-subsubmenu-close]';
var SELECTOR_MOBILE_CAROUSEL = '[data-mobile-menu-carousel]';
var SELECTOR_CAROUSEL_WRAP = '[data-mobile-menu-carousel-wrap]';
var SELECTOR_CAROUSEL_PROGRESS = '[data-carousel-progress]';
var SELECTOR_PROMOBAR_SLIDER = '[data-promobar-slider]';
var SELECTOR_PROMOBAR_CLOSE = '[data-promobar-close]'; // Elements

var ELEMENT_BODY = document.body; // Functions

var onMouseOver = function onMouseOver(element) {
  if (responsiveMediaBelow('MEDIUM')) return;
  var header = element.closest(SELECTOR_HEADER);
  if (!header) return;
  ELEMENT_BODY.classList.add(CLASS_MEGANAV_OPEN);
  element.classList.add(CLASS_MENU_OPEN);
};

var onMouseLeave = function onMouseLeave(element) {
  if (responsiveMediaBelow('MEDIUM')) return;
  var header = element.closest(SELECTOR_HEADER);
  if (!header) return;
  ELEMENT_BODY.classList.remove(CLASS_MEGANAV_OPEN);
  element.classList.remove(CLASS_MENU_OPEN);
};
/*
  Events
*/
// Menu overlay hover events


document.querySelectorAll(SELECTOR_SUBMENU_CONTAINER).forEach(function (element) {
  element.addEventListener('mouseover', function () {
    return onMouseOver(element);
  });
  element.addEventListener('mouseleave', function () {
    return onMouseLeave(element);
  });
  var submenuTriggers = document.querySelectorAll(SELECTOR_SUBMENU_TRIGGER);
  var submenuCloses = document.querySelectorAll(SELECTOR_SUBMENU_CLOSE);
  var subSubmenuCloses = document.querySelectorAll(SELECTOR_SUBSUBMENU_CLOSE);
  var subSubMenuTriggers = document.querySelectorAll(SELECTOR_SUBSUBMENU_TRIGGER);
  var carousel = document.querySelectorAll(SELECTOR_MOBILE_CAROUSEL);

  if (submenuTriggers) {
    submenuTriggers.forEach(function (submenuTrigger) {
      if (window.innerWidth < 1100) {
        submenuTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (e.currentTarget) {
            var currentTrigger = e.currentTarget;
            if (!currentTrigger.parentNode) return;
            var currentContainer = currentTrigger.parentNode;
            currentContainer.classList.add(CLASS_IS_SUBMENUING);
          }
        });
      }
    });
  }

  if (subSubMenuTriggers) {
    subSubMenuTriggers.forEach(function (subSubMenuTrigger) {
      if (window.innerWidth < 1100) {
        subSubMenuTrigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (e.currentTarget) {
            var currentTrigger = e.currentTarget;
            if (!currentTrigger.parentNode) return;
            var currentContainer = currentTrigger.parentNode;
            currentContainer.classList.add(CLASS_IS_SUBSUBMENUING);
          }
        });
      }
    });
  }

  if (submenuCloses) {
    submenuCloses.forEach(function (submenuClose) {
      if (window.innerWidth < 1100) {
        submenuClose.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (e.currentTarget) {
            element.classList.remove(CLASS_IS_SUBMENUING);
          }
        });
      }
    });
  }

  if (subSubmenuCloses) {
    subSubmenuCloses.forEach(function (subSubmenuClose) {
      if (window.innerWidth < 1100) {
        subSubmenuClose.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (e.currentTarget) {
            element.classList.remove(CLASS_IS_SUBSUBMENUING);
          }
        });
      }
    });
  }

  if (!carousel) return;
  carousel.forEach(function (c) {
    var progressBar = c.querySelector(SELECTOR_CAROUSEL_PROGRESS);
    var carouselWrap = c.querySelector(SELECTOR_CAROUSEL_WRAP);
    if (!progressBar || !carouselWrap) return;
    initCarousel(carouselWrap, {
      slidesPerView: 1,
      loop: true,
      dragSpeed: 2,
      breakpoints: _defineProperty({}, responsiveQuery('SMALL'), {
        slidesPerView: 2
      })
    }, undefined, undefined, undefined, undefined, progressBar);
  });
}); // PROMOBAR

var promoBarClose = document.querySelector(SELECTOR_PROMOBAR_CLOSE);

if (promoBarClose) {
  document.body.classList.add(CLASS_PROMOBAR);
  promoBarClose.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.currentTarget) {
      document.body.classList.remove(CLASS_PROMOBAR);
    }
  });
}

var promoBarCarousel = document.querySelector(SELECTOR_PROMOBAR_SLIDER);

if (promoBarCarousel) {
  initCarousel(promoBarCarousel, {
    slidesPerView: 1,
    loop: true,
    dragSpeed: 2,
    autoplay: true
  });
}